e4.bootstrap.modal = {
    init: function () {
        e4.bootstrap.modal.bindEvents();
    },
    bindEvents: function () {
        // TODO: Laves om så der i stedet tages højde for om modal'en ligger i et element med Translate og will-change.
        var jBody = jQuery( 'body' );
        jQuery( document ).on( 'show.bs.modal', '.modal', function ( event ) {
            jQuery( e4.settings.scrollReveal.selector ).addClass( e4.settings.scrollReveal.classReset );
            if ( jQuery( event.target ).find( '.modal-dialog' ).filter( '.modal-fullscreen' ).length === 1 ) {
                jBody.addClass( e4.settings.modal.bodyNoAdjustmentClass );
            }
        } ).on( 'shown.bs.modal', '.modal', function ( event ) {
            jQuery( event.target ).trigger( 'focus' );
        } ).on( 'hide.bs.modal', '.modal', function () {
            jBody.removeClass( e4.settings.modal.bodyNoAdjustmentClass );
        } ).on( 'hidden.bs.modal', '.modal', function () {
            jQuery( e4.settings.scrollReveal.selector ).removeClass( e4.settings.scrollReveal.classReset );
        } );
    }
};
